import {lazy, Suspense} from "react";
import CircularLoader from "../../customs/loader/main";


const Main = lazy(() => import("../../components/application/licenseRenewal/main"));

const LicenseRenewal = () => {

    return(

        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>
      
    )
};

export default LicenseRenewal;